module.exports = __webpack_public_path__ + "static/media/kitchen-serving.0bcb0684.svg";